export const PASSWORD_MIN_LENGTH = 8

export const PASSWORD_SCORE_SHIFT = 1 // We want to tell the strength of an empty password from a defined password

export const PASSWORD_MIN_SCORE = 3 + PASSWORD_SCORE_SHIFT

export const PASSWORD_MAX_SCORE = 4 + PASSWORD_SCORE_SHIFT
